import {useMemo} from "react";

import {KhanmigoSidebarContext, type KhanmigoSidebarState} from "./context.ts";

interface Props {
    /**
     * The children to render within the context provider.
     */
    children: React.ReactNode;
    /**
     * initialState for testing purposes.
     */
    initialState?: Partial<KhanmigoSidebarState>;
}

/**
 * A context provider for the Khanmigo sidebar to provision the sidebar and its
 * children with context that is specific to the sidebar.
 */
export const KhanmigoSidebarContextProvider = (props: Props) => {
    const {children, initialState} = props;
    // NOTE: We eventually want sidebar-specific state to be managed by a more
    // localized context. For now the state lives in a global GuideState, but
    // we can move it here.
    const context = useMemo(
        () => ({
            isCompanionMode: true,
            ...initialState,
        }),
        [initialState],
    );

    return (
        <KhanmigoSidebarContext.Provider value={context}>
            {children}
        </KhanmigoSidebarContext.Provider>
    );
};
